
import { Component, Vue } from 'vue-property-decorator';
import { getSimple } from '@/api/statistics';
import LogUtils from 'panda-log';
@Component
export default class RealTimeData extends Vue {
  private resHtml = '';
  private dataDefault: Date = new Date();
  private dataValue: number = 0;
  dataChange(datavalue: number) {
    this.dataValue = datavalue / 1000;
    this.getSimpleTable();
  }
  async getSimpleTable() {
    try {
      const res = await getSimple();
      this.resHtml = res as any;
    } catch (error) {
      LogUtils.debug(error);
      this.resHtml = error;
    }
  }

  mounted() {
    const start = new Date();
    this.dataValue = Math.round(start.getTime() / 1000);
    this.getSimpleTable();
  }
}
